import FormativeAssessmentsView from "@features/tools/view/formative-assessment-view";

const FormativeAssessment = () => {
  return <FormativeAssessmentsView />;
};

export default FormativeAssessment;
